import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en/translation.json";
import pl from "./locales/pl/translation.json";

// Suppress i18next's unsolicited locize.com promotional console log
const _consoleLog = console.log;
console.log = (...args: unknown[]) => {
	if (typeof args[0] === "string" && args[0].includes("locize")) return;
	_consoleLog.apply(console, args);
};

i18n.use(initReactI18next).init({
	resources: {
		en: { translation: en },
		pl: { translation: pl },
	},
	lng: "pl",
	fallbackLng: "pl",
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
